// @flow
import dag1 from '../../../static/1-intervjudag-hjemme-til-jobb.json'
import dag1_til_intervju from '../../../static/2-intervjudag-jobb-til-intervju.json'
import dag1_til_intervju_2 from '../../../static/3-intervjudag-jobb-til-intervju.json'

export type Chapter = {
  title: string,
  text: string,
  mapbox: any
}

export const chapters: Array<Chapter> = [
  {
    gdocId: 'stavanger-oversikt',
    title: 'kl. 06:00',
    text: 'Som vanlig begynte dagen med at han stod opp rundt klokken seks.',
    fallbackPicture: '1.15004918',
    mapbox: {
      id: 'stavanger-oversikt',
      duration: 4000,
      center: [5.673148, 58.985719715],
      // bounds: [[2, 40], [12, 65]],
      bounds: [[5.591992, 58.877543], [5.766621, 59.017872]],
      zoom: 11.5,
      pitch: 0,
      bearing: 0,
      mapColor: 'dark',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.988715,
        lon: 5.673099
      }
    }
  },
  {
    gdocId: 'stavanger-oversikt',
    title: '',
    text:
      'Deretter kjørte han til jobb. Vi kan ikke se akkurat når han kjørte, men tidligere hadde vi sett at han pleide å ta denne ruta til jobben.',
    fallbackPicture: '1.15004921',
    mapbox: {
      id: 'stavanger-oversikt-linje',
      duration: 7000,
      center: [5.740115, 58.891065],
      bounds: [[5.591992, 58.877543], [5.766621, 59.017872]],
      zoom: 11.5,
      pitch: 0,
      bearing: 0,
      mapColor: 'dark',
      showFocus: false,
      greatCircle: { name: 'benimambasa', data: dag1 },
      point: {
        name: 'navn3',
        lat: 58.891065,
        lon: 5.740115
      }
    }
  },
  {
    gdocId: 'stavanger-oversikt',
    title: 'kl. 11.35',
    text:
      'Neste gang mobilen avslørte posisjonen hans, var utenfor jobben. Så forflyttet han seg raskt vestover. Tempoet tilsa at han kjørte bil.',
    fallbackPicture: '1.15004925',
    mapbox: {
      id: 'stavanger-oversikt-linje',
      duration: 7000,
      center: [5.740115, 58.891065],
      bounds: [[5.591992, 58.877543], [5.766621, 59.017872]],
      zoom: 11.5,
      pitch: 0,
      bearing: 5,
      mapColor: 'dark',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.891065,
        lon: 5.740115
      }
    }
  },
  {
    gdocId: 'en',
    title: 'kl. 11:50',
    text: 'Han kjørte til et industriområde i Risavika Havnering.',
    fallbackPicture: '1.15004928',
    textAlign: 'left',
    mapbox: {
      id: 'durban',
      duration: 5000,
      center: [5.597758, 58.933906],
      bearing: 0,
      zoom: 12.2,
      pitch: 15,
      showFocus: true,
      greatCircle: { name: 'benimambasa', data: dag1_til_intervju },
      point: {
        name: 'navn3',
        lat: 58.933906,
        lon: 5.597758
      }
    }
  },
  {
    gdocId: 'to',
    title: 'kl. 11:54',
    text: 'Karl kjørte først hit, men snudde etter få minutter. ',
    fallbackPicture: '1.15004931',
    textAlign: 'left',
    mapbox: {
      id: 'tromso',
      duration: 7000,
      center: [5.597758, 58.933906],
      bearing: 0,
      zoom: 13,
      pitch: 0,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.933906,
        lon: 5.597758
      }
    }
  },
  {
    gdocId: 'tre',
    title: 'kl. 12:03',
    text: 'Til slutt fant han frem og parkerte bilen.',
    fallbackPicture: '1.15004933',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand',
      duration: 7000,
      center: [5.60279, 58.922023],
      bearing: 40,
      zoom: 14,
      pitch: 10,
      mapColor: 'red',
      showFocus: true,
      greatCircle: { name: 'benimambasa', data: dag1_til_intervju_2 },
      point: {
        name: 'navn_kontor',
        lat: 58.922023,
        lon: 5.60279
      }
    }
  },
  {
    gdocId: 'tre',
    title: 'kl. 13:00',
    text:
      'Han var i dette bygget, og beveget seg litt rundt på området. Her var han i omtrent en time.',
    fallbackPicture: '1.15004936',
    textAlign: 'left',
    mapbox: {
      id: 'kristiansand2',
      duration: 7000,
      center: [5.60279, 58.922023],
      bearing: 40,
      zoom: 15,
      pitch: 10,
      mapColor: 'red',
      showFocus: true,
      point: {
        name: 'navn3',
        lat: 58.922023,
        lon: 5.60279
      }
    }
  },
  {
    gdocId: 'start',
    title: 'kl. 13:11',
    text: 'Så kjørte han tilbake til jobben.',
    fallbackPicture: '1.15004939',
    textAlign: 'left',
    mapbox: {
      id: 'hentiesbay',
      duration: 7000,
      center: [5.740115, 58.891065],
      // bounds: [[2, 40], [12, 65]],
      zoom: 12,
      bearing: 20,
      pitch: 0,
      showFocus: true,
      point: {
        name: 'navn-slutt',
        lat: 58.891065,
        lon: 5.740115
      },
      pointCluster: {}
    }
  }
]

export function createChapters (): Array<Chapter> {
  return chapters.map(chapter => {
    return { ...chapter }
  })
}



// WEBPACK FOOTER //
// ./src/v1/components/chapters.js